module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/DVD-23277ee15e794d8c58924502dd4e0437.svg";